import CenteredLoader from './CenteredLoader';
import { Suspense, type ComponentType } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useLocation } from 'react-router';

export const LazyPage = ({ children }: { children: React.ReactNode }) => {
    const location = useLocation();

    return (
        <Suspense fallback={<CenteredLoader />}>
            <AnimatePresence
                mode="wait"
                initial={false}
            >
                <motion.div
                    key={location.pathname}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.18, ease: 'easeOut' }}
                    className="h-full"
                >
                    {children}
                </motion.div>
            </AnimatePresence>
        </Suspense>
    );
};

export const withSuspense = (Component: ComponentType) => (
    <LazyPage>
        <Component />
    </LazyPage>
);
